import { productionConfig } from './production-config.js';

export interface AmplifyAuthConfig {
  Auth: {
    Cognito: {
      userPoolId: string;
      userPoolClientId: string;
      passwordless: {
        webAuthn: {
          relyingPartyId: string;
        };
      };
    };
  };
}

export function getAmplifyConfig(): AmplifyAuthConfig {
  return {
    Auth: {
      Cognito: {
        userPoolId: productionConfig.cognito.userPoolId,
        userPoolClientId: productionConfig.cognito.userPoolClientId,
        passwordless: {
          webAuthn: {
            relyingPartyId: productionConfig.cognito.webAuthnRelyingPartyId,
          },
        },
      },
    },
  };
}
